import * as userRequest from "@/utils/userRequest";

export default async function check2FAService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("auth/authenticator", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (res.success) {
            onSuccess && onSuccess(res.data);
            return res;
        }
        throw new Error("Check 2FA failed");
    } catch (err) {
        console.error("🚀 ~ check2FAService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
